export default __webpack_public_path__ + "static/sbisompo-e4cf5caf25cf139aa0a2c3b2396a3110.png";